import { createUseStyles } from 'react-jss';

const styles = {
  tagWrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  stageIcon: {
    marginLeft: '1rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
